import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeSchemeService } from 'app/services/theme-scheme.service';

/**
 * Botón de tema claro/oscuro para la cabecera. **Solo para superadmin**: para el resto el
 * tema lo decide el sistema operativo y aquí no se pinta nada.
 *
 * El icono es el del tema al que se va, no el del que se está: en oscuro sale un sol
 * porque pulsarlo enciende la luz. Es la convención de casi todas las apps, pero como se
 * puede leer al revés, el tooltip y el `aria-label` lo dicen con palabras.
 */
@Component({
  selector: 'app-theme-toggle',
  template: `
    @if (theme.canChoose()) {
      <button
        mat-icon-button
        [matTooltip]="label()"
        [attr.aria-label]="label()"
        (click)="theme.toggle()"
      >
        <mat-icon [svgIcon]="icon()"></mat-icon>
      </button>
    }
  `,
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
})
export class ThemeToggleComponent {
  readonly theme = inject(ThemeSchemeService);

  constructor() {
    // La cabecera se crea justo después de iniciar sesión, que es el único momento en el
    // que se sabe con quién se ha entrado. Sin esto, entrar con otra cuenta en la misma
    // pestaña heredaría el tema del anterior: iniciar sesión no recarga la aplicación.
    this.theme.applyForCurrentUser();
  }

  readonly icon = computed(() =>
    this.theme.isDark() ? 'heroicons_outline:sun' : 'heroicons_outline:moon',
  );

  readonly label = computed(() =>
    this.theme.isDark() ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro',
  );
}
